import axios from "@/utils/axiosHelper";

// 初始化
export const onGetInitDataAPI = params => {
    return axios({
        url: "/sea/america/year/index",
        method: "GET",
        params
    }, { interceptResultCode: false });
};

// 获取登录信息
export const onGetAccountDataAPI = params => {
    return axios({ url: "/sea/sms/login", method: "POST", params }, { interceptResultCode: false });
};

// 免密登录
export const onGetFreeLoginAPI = params => {
    return axios({ url: "/sea/login", method: "POST", params }, { interceptResultCode: false });
};

// 点击预约
export const appointAPI = params => {
    return axios({
        url: "/sea/america/year/book",
        method: "POST",
        params
    }, { interceptResultCode: false });
};

// 组队 初始化
export const teamInitAPI = params => {
    return axios({
        url: "/sea/america/year/team",
        method: "GET",
        params
    }, { interceptResultCode: false });
};

// 组队 加入队伍
export const teamJoinAPI = data => {
    return axios({
        url: "/sea/america/year/team/join",
        method: "POST",
        data
    }, { interceptResultCode: false });
};

// 组队 踢出队伍
export const teamKickAPI = data => {
    return axios({
        url: "/sea/america/year/team/exit",
        method: "POST",
        data
    }, { interceptResultCode: false });
};

// 组队 退出队伍
export const teamExitAPI = data => {
    return axios({
        url: "/sea/america/year/team/out",
        method: "POST",
        data
    }, { interceptResultCode: false });
};

// 组队 领取奖励
export const teamRewardAPI = params => {
    return axios({
        url: "/sea/america/year/reward",
        method: "POST",
        params
    }, { interceptResultCode: false });
};

// 获取角色列表
export const GetRoleList = params => {
    return axios({ url: "/sea/server/query", method: "GET", params }, { interceptResultCode: false });
};

// 获取服务器时间
export const onGetTimeAPI = params => {
    return axios({ url: "/snail/year/show", method: "GET", params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/thirdAnniversary/api.js